import { withStyles } from '../../tools/withStyles';
import { withAnimation } from '../../tools/withAnimation';
import { withSounds } from '../../tools/withSounds';
import { Component } from './Text';
import { styles } from './Text.styles';

const Text = withStyles(styles)(withAnimation()(withSounds()(Component)));

export { Text };

// Commit trace: 2025-07-07T19:28:55 - feat: introduce dynamic logic to index.js

// Commit trace: 2025-11-27T04:09:28 - docs: improve documentation in index.js

// Commit trace: 2026-03-13T20:38:52 - perf: speed up execution in index.js
